/* eslint-disable */
import {
  Box,
  TextareaAutosize,
  Checkbox,
  Typography,
  FormControlLabel
} from '@mui/material'

import { textAreaStyle } from '../../constants/styleConstants'
import CardTAG from '../CardTAG'
import React from 'react'
import FormLayout from '../forms/FormLayout'
import { useDispatch, useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { AppDispatch } from '../../store'
import {
  updateAnswerText,
  findItemByUuid
  
} from '../../store/reports/reportsSlice'
import { IQuestionComponent } from './types'
import authSelectors from '../../store/auth/authSelectors'

const OpenUnknowQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  parent,
  previewOnly = false,
}) => {
  

  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const dispatch = useDispatch<AppDispatch>()
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = getAnswer()

  const onChangeHandler = (event: { target: { value: string, checked?: any | undefined } }) => {
    let value = event?.target?.value
    if (typeof event?.target?.checked != 'undefined' && !event?.target?.checked) {	
      value = ''
    }
    dispatch(
      updateAnswerText({
        answerUUID: answer?.uuid,
        answerText: value,
        parentUUID: parent?.uuid,
        questionId
      }),
    )
  }

  return (
    <div id={`${questionId}`}>
      <CardTAG
        questionCard={true}
        color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
        title={
          <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
            <Typography
              variant='h4'
              sx={{
                wordWrap: 'break-word',
                overflow: 'hidden',
              }}
            >
              {question}
            </Typography>
          </Box>
        }
        
      >
            <FormLayout>
              <FormControlLabel
                control={
                  <Checkbox
                    value={'Unknown'}
                    onChange={onChangeHandler}
                    checked={answer?.answer?.text == 'Unknown'}
                    disabled={!userEditAccess || previewOnly}
                  />
                }
                label={'Unknown'}
              />
              {answer?.answer?.text != 'Unknown' && <TextareaAutosize
                  onChange={onChangeHandler}
                  value={answer?.answer?.text}
                  style={textAreaStyle}
                  minRows={5}
                  placeholder={'Description'}
                  disabled={!userEditAccess || previewOnly}
              />}
            </FormLayout>
        
        </CardTAG>
      </div>
  )
  
}

export default OpenUnknowQuestionComponent
